export default __webpack_public_path__ + "static/media/joinTeam.03c047e4.svg";